/* Pure sold-collection ordering. Shared by the browser and the offline proof suite.
 * A traversal pins identity positions; removals leave holes instead of shifting page boundaries.
 * Stock/publication truth is supplied afresh by Shopify, never by browser storage. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.FJBCSoldRotation = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  var VERSION = 1, AWAY_MS = 30 * 60 * 1000, HISTORY_MS = 30 * 24 * 60 * 60 * 1000;
  function unique(values) {
    if (!Array.isArray(values)) return [];
    return Array.from(new Set(values.filter(function (id) {
      return typeof id === 'string' && /^[a-z0-9][a-z0-9-]{0,254}$/.test(id);
    })));
  }
  function shuffle(values, seed) {
    var result = values.slice(), state = seed >>> 0;
    function random() {
      state += 0x6D2B79F5;
      var t = Math.imul(state ^ state >>> 15, 1 | state);
      t ^= t + Math.imul(t ^ t >>> 7, 61 | t);
      return ((t ^ t >>> 14) >>> 0) / 4294967296;
    }
    for (var i = result.length - 1; i > 0; i--) {
      var j = Math.floor(random() * (i + 1)), old = result[i]; result[i] = result[j]; result[j] = old;
    }
    return result;
  }
  function valid(saved, now) {
    return !!saved && saved.version === VERSION && Number.isFinite(saved.createdAt) &&
      saved.createdAt <= now && now - saved.createdAt < HISTORY_MS &&
      Array.isArray(saved.order) && unique(saved.order).length === saved.order.length;
  }
  function start(pool, saved, options) {
    var now = options.now, members = unique(pool);
    if (!Number.isFinite(now)) throw new Error('A finite clock is required');
    var previous = valid(saved, now) ? saved : null;
    // Existing navigation always wins over a new-visit clock. Reading an open tab is not "away".
    var expiredVisit = Number.isFinite(options.awaySince) && options.awaySince <= now &&
      now - options.awaySince >= AWAY_MS;
    if (previous && (!options.freshEntry || !expiredVisit)) {
      return { version: VERSION, createdAt: previous.createdAt, order: previous.order.slice(),
        seen: unique(previous.seen), last: unique(previous.last) };
    }
    var live = new Set(members), seen = new Set(previous ? unique(previous.seen).filter(function (id) { return live.has(id); }) : []);
    if (members.every(function (id) { return seen.has(id); })) seen.clear();
    var order = shuffle(members, options.seed), unseen = order.filter(function (id) { return !seen.has(id); });
    var visited = order.filter(function (id) { return seen.has(id); });
    order = unseen.concat(visited);
    // At a cycle boundary, avoid the immediately preceding displayed group when alternatives exist.
    if (!seen.size && previous) {
      var last = new Set(unique(previous.last));
      order = order.filter(function (id) { return !last.has(id); }).concat(order.filter(function (id) { return last.has(id); }));
    }
    return { version: VERSION, createdAt: now, order: order, seen: Array.from(seen), last: [] };
  }
  function expose(state, identities) {
    var validIds = new Set(state.order), last = unique(identities).filter(function (id) { return validIds.has(id); });
    return Object.assign({}, state, { seen: unique(state.seen.concat(last)), last: unique(state.last.concat(last)) });
  }
  function page(order, live, pageNumber, size) {
    if (!Number.isSafeInteger(pageNumber) || pageNumber < 1 || !Number.isSafeInteger(size) || size < 1 || size > 250) return [];
    var eligible = new Set(unique(live));
    return order.slice((pageNumber - 1) * size, pageNumber * size).filter(function (id) { return eligible.has(id); });
  }
  function interleave(current, sold) {
    // 23 current + 1 sold = 24 cards. No replacement; short pages never lead with sold.
    var candidates = unique(sold).slice(0, 2), result = [], index = 0;
    current.forEach(function (item, at) {
      result.push({ kind: 'current', id: item });
      if ((at === 22 || at === 45) && index < candidates.length) result.push({ kind: 'sold', id: candidates[index++] });
    });
    return result;
  }
  function normalizeURL(href, key, value) {
    var url = new URL(href);
    if (!/^filter\.p\.m\.fjbc\.[a-z_]+$/.test(key) || typeof value !== 'string' || !value) throw new Error('Invalid native filter');
    url.searchParams.delete(key); url.searchParams.set(key, value);
    return url;
  }
  return { VERSION: VERSION, AWAY_MS: AWAY_MS, HISTORY_MS: HISTORY_MS, unique: unique,
    shuffle: shuffle, start: start, expose: expose, page: page, interleave: interleave, normalizeURL: normalizeURL };
});
